<template>
  <div>
    <!-- Hidden upload handler -->
    <UploadFiles
      ref="uploader"
      v-model="files"
      :options="{
        limit: 1,
        accept: ['image/jpeg', 'image/png', 'video/mp4'],
        multiple: false,
      }"
      class="hidden"
      @change="onFilePicked"
    />

    <!-- Trigger button -->
    <el-button
      v-if="$is_GD"
      :disabled="!canUploadReplaceAndDeleteFile(creative?.status)"
      @click="triggerBrowse"
      type="text"
      :class="[
        'w-[40px] h-[40px] flex justify-center items-center',
        { 'is-disabled opacity-50': !canUploadReplaceAndDeleteFile(creative?.status) },
      ]"
    >
      <svg class="text-gray" width="12" height="12" fill="none">
        <use xlink:href="#replace-img" />
      </svg>
    </el-button>
  </div>
</template>

<script>
import UploadFiles from '@/components/social-products/social-boost/parts/UploadFiles.vue'
import CreativesMixin from '@/mixins/social-products/Creatives.js'

export default {
  name: 'ReplaceFile',
  mixins: [CreativesMixin],
  components: { UploadFiles },
  props: {
    creative: {
      type: Object,
      default: () => null,
    },
    creativeId: {
      type: [String, Number],
      required: true,
    },
    fileId: {
      type: [String, Number],
      required: true,
    },
    flightStatus: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      files: [],
    }
  },
  methods: {
    triggerBrowse() {
      this.$refs.uploader.selectFiles()
    },
    async onFilePicked(files) {
      const file = files?.[0]
      if (!file) return

      this.$emit('replacing', true)

      try {
        await this.$store.dispatch('socialBoostCampaign/replaceCreativeFiles', {
          creative_id: this.creativeId,
          file_id: this.fileId,
          files: [file],
        })
        this.$emit('replaced')
      } catch (e) {
        console.error(e)
      } finally {
        this.$emit('replacing', false)
      }
    },
  },
}
</script>
